<template>
    <FilterPage title="Type de structure" v-on="$listeners" @reset="handleReset">
        <b-form-radio-group
            class="search-checkboxes search-checkboxes--bold mt-4"
            :checked="isConventioned"
            stacked
            @change="handleConventionedChanged"
        >
            <div class="list-group list-group-flush">
                <div class="list-group-item list-group-item-action search-checkboxes__item" @click="handleItemClicked">
                    <b-form-radio class="search-checkboxes__checkbox font-weight-bold" :value="null">
                        Tous les lieux
                    </b-form-radio>
                </div>
                <div class="list-group-item list-group-item-action border-bottom-0 search-checkboxes__item" @click="handleItemClicked">
                    <b-form-radio class="search-checkboxes__checkbox font-weight-bold" value="yes">
                        Lieux labellisés
                        <template v-if="isConventioned === 'yes' && !hasLabels">
                            (tous)
                        </template>
                    </b-form-radio>
                </div>
                <b-collapse :visible="isConventioned === 'yes'">
                    <div class="list-group-item border-top-0">
                        <CheckboxesCriteria
                            class="text-transform-none"
                            v-model="value.venues.labels"
                            :options="checkboxesOptions"
                            @change="handleChanged"
                            ref="checkboxes"
                        />
                    </div>
                </b-collapse>
                <div class="list-group-item list-group-item-action search-checkboxes__item" @click="handleItemClicked">
                    <b-form-radio class="search-checkboxes__checkbox font-weight-bold" value="no">
                        Lieux non labellisés
                    </b-form-radio>
                </div>
            </div>
        </b-form-radio-group>
    </FilterPage>
</template>

<script>
    import FilterPage from "../../../FilterPage.vue";
    import CheckboxesCriteria from "../../criterias/Checkboxes.vue";
    import { BFormRadioGroup, BFormRadio, BFormCheckbox } from 'bootstrap-vue';

    export default {
        components: {
            FilterPage,
            CheckboxesCriteria,
            BFormRadio,
            BFormRadioGroup,
            BFormCheckbox,
        },
        props: {
            value: Object,
            criterias: Object,
        },
        computed: {
            checkboxesOptions() {
                return this.criterias.venues.labels;
            },
            isConventioned() {
                return this.value.venues.conventioned || null;
            },
            hasLabels() {
                return (this.value.venues.labels || []).length > 0;
            }
        },
        methods: {
            setConventionned(conventioned) {
                if(conventioned !== 'yes') {
                    this.value.venues.labels = [];
                }
                this.$emit('input', {
                    ...this.value,
                    venues: {
                        ...this.value.venues,
                        conventioned,
                    }
                });
            },
            handleChanged() {
                this.$emit('input', { ...this.value });
            },
            handleConventionedChanged(conventioned) {
               this.setConventionned(conventioned);
            },
            handleItemClicked(e) {
                const radio = e.target.querySelector('input[type=radio]');
                if(radio) {
                    radio.click();
                }
            },
            handleReset() {
                this.setConventionned(null);
            },
        },
    }
</script>
